
import { Options, Vue, prop } from "vue-class-component";
import MultipleSelectSearch from "@/app/ui/components/multiple-select-search/index.vue";
import Search from "@/app/ui/components/search/index.vue";
import { RevenueDashboardController } from "@/app/ui/controllers/RevenueDashboardController";

class Props {
  modelValue = prop<string[]>({
    default: () => [],
    type: Array
  });
}

@Options({
  name: "CustomerLeaderboardTagFilter",
  components: { MultipleSelectSearch, Search },
  emits: ["update:modelValue", "change"]
})
export default class CustomerLeaderboardTagFilter extends Vue.with(Props) {
  get tagLabels() {
    return [
      this.$t("dashboard.customerLeaderboardFilter.omzetUp") as string,
      this.$t("dashboard.customerLeaderboardFilter.omzetDown") as string,
      this.$t("dashboard.customerLeaderboardFilter.churnCustomer") as string,
      this.$t("dashboard.customerLeaderboardFilter.newCustomer") as string,
      "RTS > 5%",
      "MISSBOOKING > 5%"
    ];
  }

  isOpenMenu = false;
  valueSearch = "";

  dataSelect: Array<{ name: string; value: string; isActive: boolean }> = [];

  created() {
    const preset = new Set(this.activeCustomerLeaderboardTags || []);
    this.dataSelect = [
      ...this.tagLabels.map(label => ({
        name: label,
        value: label,
        isActive: preset.has(this.toSnakeCase(label))
      }))
    ];
  }


  get customerLeaderboardSearchQuery() {
    return RevenueDashboardController.customerLeaderboardSearchQuery;
  }
  get activeCustomerLeaderboardTags() {
    return RevenueDashboardController.activeCustomerLeaderboardTags;
  }


  onLeaderboardSearch = (value: string) => {
    RevenueDashboardController.setCustomerLeaderboardSearch(value ?? "");
  };
  onLeaderboardClear = () => {
    RevenueDashboardController.setCustomerLeaderboardSearch("");
  };


  private toSnakeCase(label: string): string {
    return String(label)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "");
  }

  get optionsBySearch() {
    const q = this.valueSearch.toLowerCase();
    return q
      ? this.dataSelect.filter(i => i.name.toLowerCase().includes(q))
      : [];
  }

  onOpenSelect = () => {
    this.isOpenMenu = true;
  };
  onCloseSelect = () => {
    this.isOpenMenu = false;
  };
  onTyping = (val: string) => {
    this.valueSearch = val || "";
  };

  onChooseSelect = (name: string, value: string) => {
    if (value === "all") {
      const someActive = this.dataSelect.some(i => i.value !== "all" && i.isActive);
      this.dataSelect = this.dataSelect.map(i =>
        i.value === "all"
          ? { ...i, isActive: !someActive }
          : { ...i, isActive: !someActive }
      );
    } else {
      this.dataSelect = this.dataSelect.map(i =>
        i.value === value ? { ...i, isActive: !i.isActive } : i
      );
      const allTagsActive = this.dataSelect
        .filter(i => i.value !== "all")
        .every(i => i.isActive);
      this.dataSelect = this.dataSelect.map(i =>
        i.value === "all" ? { ...i, isActive: allTagsActive } : i
      );
    }

    const selectedLabels = this.dataSelect
      .filter(i => i.value !== "all" && i.isActive)
      .map(i => i.value);


    const snakeTags = selectedLabels.map(this.toSnakeCase);
    RevenueDashboardController.setCustomerLeaderboardTags(snakeTags);

    this.$emit("update:modelValue", selectedLabels);
    this.$emit("change", selectedLabels);
  };
}
